import ReactMarkdown from 'react-markdown';
import { Container } from '@mui/material';

const md = `
# **Договор-оферта оказания услуг по предоставлению доступа к программному обеспечению (веб-сервису) Typhon**

**Г.Подольск** &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; **17 апреля 2026г.**

---

## **1. Общие положения**

**1.1.** Настоящий публичный договор (далее - Оферта) представляет собой официальное предложение  **ИП МЕЛЬНИК ВАДИМ ПАВЛОВИЧ** (далее — Оператор), адресованное любому физическому и юридическому лицам (далее – Пользователь), и содержит все существенные условия по оказанию услуг по предоставлению доступа к программному обеспечению (веб-сервису) Typhon.

**1.2.** В соответствии с пунктом 2 статьи 437 Гражданского Кодекса Российской Федерации (далее – ГК РФ) данный документ является публичной офертой и, в случае принятия изложенных ниже условий и оплаты услуг Оператора, лицо, совершившее акцепт этой Оферты, становится Пользователем в соответствии с пунктом 3 статьи 438 ГК РФ, акцепт Оферты равносилен заключению договора на условиях, изложенных в Оферте.

**1.3.** Осуществляя оплату услуг, Пользователь гарантирует, что уже ознакомлен и принимает все условия Оферты в том виде, в каком они изложены в тексте настоящей Оферты, а также ознакомлен со стоимостью Услуги, указанными на Сайте Оператора.

---

## **2. Термины и определения**

**2.1. Акцепт оферты** – полное и безоговорочное принятие оферты путем осуществления Пользователем действий по внесению предварительной оплаты за оказание услуг по предоставлению доступа к программному обеспечению (веб-сервису) Typhon. Акцепт оферты создает Договор оферты.

**2.2. Договор оферты** – договор между Оператором и Пользователем на оказание услуг по предоставлению доступа к программному обеспечению (веб-сервису) Typhon, который заключается посредством акцепта Оферты.

**2.3. Пользователь** – лицо, осуществившее акцепт оферты, и являющееся таким образом Пользователем.

**2.4. Оферта** – настоящий документ Договор-оферта на оказание услуг по предоставлению доступа к программному обеспечению (веб-сервису) Typhon Оператором, опубликованный в сети Интернет по адресу: **https://tgtyphon.com/terms**

> Пользователь самостоятельно определяет способы и цели использования функционала Сервиса и несёт полную ответственность за такие действия.

---

## **3. Предмет договора**

**3.1.** Предметом настоящей Оферты является возмездное оказание Оператором услуг по предоставлению доступа к программному обеспечению (веб-сервису) Typhon (далее - "Сервис"), в порядке и сроки, предусмотренные настоящей Офертой.

**3.2. Правовая природа Сервиса**

- Сервис предоставляет Пользователю программный инструмент автоматизации работы с Telegram.
- Сервис не является средством массовой рассылки сообщений и не предназначен для осуществления спама или иной запрещённой деятельности.
- Оператор осуществляет предоставление доступа и передает неисключительную лицензию на право пользования Сервисом.
- Права на Сервис остаются у Оператора.

**3.3.** Пользователь подтверждает, что до момента заключения Договора (Акцепта настоящей Оферты) получил от Оператора всю полную информацию о сроках, порядке оказания услуг, привлекаемыми исполнителями.

**3.4.** Пользователь подтверждает, что результатом услуг в рамках настоящей Оферты будут являться действия Оператора по доступу к Сервису и пользование его функционала.

**3.4.** Перечень услуг Оператора в сети Интернет расположен на сайтах: **https://tgtyphon.com**

**3.5.** Оператор имеет право в любой момент изменять условия настоящей публичной оферты в одностороннем порядке без предварительного согласования с Пользователем, обеспечивая при этом публикацию измененных условий в Интернете на сайтах, указанных в п.2.4 настоящей Оферты.

---

## **4. Заверения и гарантии Сторон**

**4.1.** Оператор заверяет и гарантирует, что является самозанятым, зарегистрирован в Межрайонная инспекция Федеральной налоговой службы №5 по Московской области г.о. Подольск.

**4.2.** Пользователь заверяет и гарантирует, что, совершая действия по акцепту Оферты, он:

**4.2.1.** имеет законные права вступать в договорные отношения с Оператором;

**4.2.2.** достиг возраста **18 лет**, является дееспособным.

---

## **5. Порядок и условия предоставления услуг**

**5.1.** В соответствии с условиями Оферты Оператор обязуется оказать услуги, а Пользователь обязуется их оплатить.

**5.2.** Виды и наименование, срок оказания, стоимость и иные характеристики предоставляемых услуг публикуются на Сайте **https://tgtyphon.com**

**5.3.** В случае невозможности предоставления услуги в назначенный срок, Оператор обязан предупредить Пользователя за один рабочий день до заявленной даты и перенести предоставление Услуг на другое время. Предупреждение осуществляется путем публикации на Сайтах соответствующих сведений или уведомлением по согласованным с пользователем каналам.

---

## **6. Порядок расчетов**

**6.1.** Оплата услуг осуществляется путем внесения **100% предоплаты**.

**6.2.** Датой оплаты признается поступление денежных средств на расчетный счет Оператора.

**6.3.** Оплата услуг по настоящему Договору осуществляется: безналичным перечислением денежных средств на расчетный счет Оператора.

**6.4.** Пользователь самостоятельно несет ответственность за правильность производимых им платежей.

**6.5.** Услуги подлежат оказанию Оператором только на условиях предварительной оплаты, осуществлённой Пользователем в соответствии с условиями настоящей Оферты.

**6.6.** Порядок оплаты и условия оказания услуг:

**6.6.1.** Пользователь оплачивает стоимость услуг в размере, указанном в **https://tgtyphon.com** заблаговременно, обеспечивая поступление денежных средств на счет Оператора до времени предоставления услуги.

**6.6.2.** При оформлении заказа Пользователь обязан предоставить персональную информацию и контактные данные, необходимые для исполнения Оператором своих обязательств. Пользователь дает согласие на обработку Оператором этих данных и использование их для рассылок информационных новостей Оператора посредством согласованных с пользователем каналов. Оператор принимает на себя обязательства сохранения конфиденциальности персональных данных Пользователя. Одновременно с вышеуказанным согласием на обработку персональных данных Пользователя также дают свое полное согласие на получение сообщений от Оператора посредством согласованных с пользователем каналов, в том числе сообщений рекламного содержания.

---

## **7. Обязанности Сторон**

**7.1. Пользователь обязуется:**

**7.1.1.** Оплачивать услуги в порядке, предусмотренном Офертой, в указанные в нём сроки.

**7.1.2.** Самостоятельно обеспечивать техническую возможность пользования услугами Оператора со своей стороны, а именно:

- надлежащий доступ в интернет (с любого технического устройства);
- наличие программного обеспечения, совместимого с передачей информации от Оператора и других необходимых средств.

**7.1.3.** Договор-оферта не может быть отозван Пользователем.

**7.2.** Оператор обязан: сохранять анонимность, кроме случаев, в которых совершены или могут быть совершены преступления, указанные в Уголовном кодексе Российской Федерации.

**7.3.** Использовать все личные данные и иную конфиденциальную информацию о Пользователе только для оказания Услуг, не передавать и не показывать третьим лицам, находящуюся у него документацию и информацию о Пользователе.

**7.4.** Проявлять уважение к Пользователю, не нарушать прав Пользователя на свободу совести, информации, на свободное выражение собственных мнений и убеждений.

---

## **8. Права Сторон**

**8.1. Пользователь вправе:**

**8.1.1.** Требовать надлежащего и своевременного оказания Услуг Оператором.

**8.1.2.** Обращаться к Оператору по всем вопросам, связанным с оказанием Услуг, а также задавать вопросы, связанные с оказанием Услуг.

**8.1.3.** Отказаться от рассылки по электронной почте, если Пользователь хочет отказаться от любого вида рассылки, он должен направить запрос на электронную почту, указанную на Сайте Оператора или в настоящей Оферте.

**8.2. Оператор вправе:**

**8.2.1.** Привлекать для оказания услуг соисполнителей или третьих лиц по своему выбору.

**8.2.2.** По своему усмотрению определять и устанавливать стоимость услуг.

**8.2.3.** Оказывать услуги только после внесения Пользователем предоплаты и акцепта настоящей Оферты.

**8.2.4.** Получать от Пользователя любую информацию, необходимую для исполнения своих обязательств по Оферте. В случае непредставления либо неполного или неверного представления Пользователем информации, Оператор вправе приостановить исполнение своих обязательств до представления необходимой информации в полном объеме.

**8.2.5.** Приостанавливать, ограничивать или прекращать предоставление услуг Пользователю в любое время без объяснения причин, с предварительным уведомлением, или без такового.

**8.2.6.** Вынести Пользователю предупреждение о прекращении действий, нарушающих условия настоящей Оферты, и прекратить Оферту в случае продолжения Пользователем таких действий.

---

## **9. Ответственность Сторон и разрешение споров**

**9.1. Предмет и предел ответственности**

- Сервис предоставляет Пользователю техническую возможность автоматизированного управления принадлежащими ему аккаунтами в Telegram, а также инструменты обработки и хранения данных.
- Сервис не является владельцем, оператором или администратором аккаунтов Пользователя и не осуществляет контроль за их содержанием и действиями, совершаемыми через такие аккаунты.
- Все действия, совершаемые через подключённые аккаунты, осуществляются исключительно от имени и по инициативе Пользователя.

**9.2. Пользователь самостоятельно и в полном объёме несёт ответственность за:**

- содержание публикуемых сообщений и комментариев;
- отправку рассылок и сообщений;
- использование функций парсинга;
- загрузку, хранение и распространение файлов, и их содержание;
- соблюдение законодательства РФ и иных применимых норм;
- соблюдение правил платформы Telegram.

**9.3. Пользователь гарантирует, что использование Сервиса не нарушает:**

- действующее законодательство РФ;
- права третьих лиц;
- правила и условия Telegram;
- нормы о защите персональных данных;
- нормы об экстремистских материалах, порнографии, спаме и незаконной рекламе.

**9.4. Запрещённое использование.**

Пользователю **запрещается** использовать Сервис для:

- распространения спама;
- массовых несанкционированных рассылок;
- распространения порнографических материалов;
- распространения экстремистских, запрещённых или незаконных материалов;
- незаконного сбора персональных данных;
- иных действий, нарушающих законодательство РФ или правила Telegram.

> В случае выявления таких действий Оператор вправе немедленно ограничить или прекратить доступ к Сервису без возврата денежных средств.

**9.5. Хранение данных (S3)**

- Данные, включая медиафайлы, загружаемые или формируемые Пользователем, хранятся в облачном хранилище.
- Оператор предоставляет исключительно техническую инфраструктуру хранения и не осуществляет предварительный контроль содержания файлов.
- Пользователь подтверждает, что обладает всеми необходимыми правами на размещаемые материалы.
- Вся ответственность за содержание хранимых файлов несёт Пользователь.

**9.6. Отсутствие солидарной ответственности**

- Оператор не является соучастником, организатором либо пособником действий Пользователя.
- Оператор не несёт ответственности за блокировки аккаунтов Пользователя со стороны Telegram.
- Оператор не несёт ответственности за убытки, возникшие вследствие неправомерных действий Пользователя.

**9.7. Возмещение убытков**

- Пользователь обязуется возместить Оператору все убытки, штрафы, претензии и требования третьих лиц, возникшие вследствие действий Пользователя.

**9.8.** Стороны несут ответственность за неисполнение или ненадлежащее исполнение своих обязательств по настоящей Оферте в соответствии с действующим законодательством РФ.

**9.9.** Оператор не несет ответственности за невозможность оказания Услуг Оператором/принятием Услуг Пользователем, если такая невозможность возникла вследствие нарушения работы в сети Интернет, программного обеспечения или оборудования Пользователя.

**9.10.** Любые требования Пользователя рассматриваются только на основании обоснованного письменного требования, направленного Исполнителю по адресам, указанным настоящей Оферте.

**9.11.** Пользователь также несет ответственность за соблюдение им требований законодательства об авторских правах и об интеллектуальной собственности.

**9.12.** В случае возникновения спора Стороны предпримут все возможные способы по его урегулированию. При невозможности разрешения спора, Стороны передают его на разрешение суда, согласно действующему законодательству РФ.

**9.13.** Оператор не несет ответственности за результат использования, полезность или последствия оказываемых Услуг. В случае несоответствия состава Услуг, предоставляемых в рамках действующего Договора-оферты, потребностям Пользователя, Оператор ответственности не несет. Для понимания подходят ли Пользователю Услуги, предоставляемые Сервисом, Пользователю предоставляется бесплатные пробный период с доступом ко всем функциям Сервиса.

---

## **10. Срок действия Оферты. Основания и порядок расторжения Оферты**

**10.1.** Оферта вступает в силу с момента регистрации Пользователем учетной записи на Сайте Оператора, указанным в настоящей Оферте и действует до полного исполнения Сторонами своих обязательств.

**10.2.** Оферта не требует скрепления печатями и/или подписания Пользователем и Оператором, сохраняя при этом полную юридическую силу.

**10.3.** Оператор оставляет за собой право внести изменения в условия Оферты и/или отозвать Оферту в любой момент по своему усмотрению. В случае внесения изменений в Оферту, такие изменения вступают в силу с момента опубликования на Сайте, если иной срок вступления в силу не установлен или не определен при опубликовании изменений Оферты.

**10.4.** Оферта может быть расторгнута досрочно по соглашению Сторон в любое время путем подписания соглашения о расторжении Оферты. В указанном случае датой расторжения Оферты считается дата подписания указанного соглашения. Соглашение может быть оформлено в виде обмена письмами, согласно которым следует волеизъявление каждой из Сторон о расторжении Оферты, а также определен и согласован порядок распоряжения денежными средствами.

---

## **11. Форс-мажор**

**11.1.** Стороны освобождаются от ответственности за полное или частичное неисполнение обязательств по Оферте в случае, если неисполнение обязательств явилось следствием действий непреодолимой силы, а именно: пожара, наводнения, землетрясения, забастовки, войны, действий органов государственной власти или других независящих от Сторон обстоятельств.

**11.2.** Сторона, которая не может выполнить обязательства по Оферте, должна своевременно, но не позднее **пяти календарных дней** после наступления обстоятельств непреодолимой силы, письменно известить другую Сторону, с предоставлением обосновывающих документов, выданных компетентными органами.

**11.3.** Оператор не несет ответственности за временные сбои и перерывы в работе интернет ресурсов Оператора и вызванную ими потерю информации.

---

## **12. Прочие условия**

**12.1.** Стороны признают, что, если какое-либо из положений Оферты становится недействительным в течение срока его действия вследствие изменения законодательства, остальные положения Оферты обязательны для Сторон в течение срока действия Оферты.

---

## **13. Реквизиты Оператора ИП МЕЛЬНИК ВАДИМ ПАВЛОВИЧ**

---
**ИНН:**  503622466004 
---
**Номер счёта:**  40802810900009557181 
---
**Банк:**  АО «ТБанк» 
---
**Корр. счёт:** 30101810145250000974 
---
**БИК:**  044525974 
---
**Телефоны:**  +79932750608 
---
**ОГРНИП:**  326508100231095 
---
**E-mail:**  tgtyphon@yandex.ru 
---
`;

export default function Terms() {
  return (
    <Container sx={{ py: 8 }}>
      <ReactMarkdown
        components={{
          ul: ({ children }) => (
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem', listStyleType: 'disc' }}>
              {children}
            </ul>
          ),
          li: ({ children }) => (
            <li style={{ marginBottom: '0.25rem' }}>
              {children}
            </li>
          ),
        }}
      >
        {md}
      </ReactMarkdown>
    </Container>
  );
}